module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news-modal"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("We are coming to your club for a free weather training!")]), _vm._v(" "), _c('p', [_vm._v("First meetings: Southern French Alps, Spain, Portugal")]), _vm._v(" "), _c('p', [_c('button', {
    on: {
      "click": function($event) {
        _vm.open()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar"
  }), _vm._v(" "), _c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("See the dates / Learn more")])], 1), _vm._v(" "), _c('button', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("Close")])], 1)]), _vm._v(" "), _c('p')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Meteo-Parapente Tour 2022")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9292de6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/news.vue
// module id = 351
// module chunks = 1